import { /* FolderTreeNodeStats, */ Model, User } from "@bimdata/definitions/dto";
import { Section } from '@/state/types/section';
import { ModelStatus } from "@bimdata/definitions/const";

export default (input: Model[]/*, tree: FolderTreeNodeStats[]*/): { models: Section[] } => {
  const models: Section[] = [];
  // const modelsMap: Map<number, ModelData> = new Map();

  const sections: Map<string | null, Section> = new Map();

  input.forEach((m) => {
    const s = m.section;

    if (!sections.has(s)) {
      const sect = { name: s, elements: 0, geometries: 0, models: [], ready: true };
      sections.set(s, sect);
      models.push(sect);
    }
    const section = sections.get(s)!;

    let elements = m.misc?.elements || 0;
    let geometries = m.misc?.geometries || 0;

    section.elements += elements;
    section.geometries += geometries;

    section.ready = section.ready && m.status == ModelStatus.READY;

    const mdl = {
      id: m.id,
      name: m.name,
      section: m.section,
      filename: m.filename,
      ready: m.status == ModelStatus.READY,
      failed: m.status == ModelStatus.ERROR,
      error: (m.status == ModelStatus.ERROR) ? m.misc?.error?.message : undefined,
      elements,
      geometries,
      views: m.misc && m.misc.info && Array.isArray(m.misc.info.views) ? m.misc.info.views : [],
      loaded: m.loaded,
      revitVersion: m.misc?.info?.optional?.revitVersion,
      sourceSize: m.sourceSize || m.misc?.sourceSize || 0,
      author: m.author as User,
    };

    // modelsMap.set(m.id, mdl);
    section.models.push(mdl);
  });

  return { models };
};